export default __webpack_public_path__ + "static/media/pizza.0a2559e3.png";